import {
  getList
} from "@/api/list";

export default {
  namespaced: true,
  state: {
    list: []
  },
  actions: {
    // 获取列表
    async getList(context, params) {
      const { data } = await getList(params);
      return data;
    }
  }
};
